<div class=" {{themeService.themeCssClass}}">
    <div *ngIf="isManager">
        <h4>REGION: {{countrySettingsCode}}</h4>
        <div>
            <mat-tab-group #tabChange>
                <mat-tab label="Work Abroad">
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <mat-card class="day-cards green-card" *ngIf="isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Team Work Abroad
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{getDisplayValueWork.get('leaveEntitlement')}}
                            </mat-card-content>
                        </mat-card>

                        <mat-card class="day-cards red-card resize" *ngIf="isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Remaining Days
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{getDisplayValueWork.get('remainingDays')}}
                            </mat-card-content>
                        </mat-card>

                        <mat-card class="day-cards amber-card resize" *ngIf="!isChecked">
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Work Abroad Days
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{getDisplayValueWork.get('pendingDays')}}
                            </mat-card-content>
                        </mat-card>

                        <mat-card class="day-cards blue-card resize-blue" *ngIf="!isChecked">
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Work Abroad Requests
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{getDisplayValueWork.get('pendingRequests')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards blue-card resize-blue" *ngIf="isChecked">
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Team Work Abroad Used
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{getDisplayValueWork.get('daysUsed')}}
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <br/>
                    <div fxLayoutAlign="center" fxLayout="row wrap" fxLayoutGap="8%">
                        <mat-form-field appearance="outline">
                            <mat-label>Search (First and Last Name)/GMIN</mat-label>
                            <input matInput (keyup)="filterTableDataSources()" #input [(ngModel)]="searchValue">
                            <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear"
                                    (click)="searchValue=''; filterTableDataSources()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Team</mat-label>
                            <mat-select #teamSelected [(value)]="filterEntity.teamName"
                                        (selectionChange)="calculateDisplayValue(filterEntity.year,teamSelected.value)">
                                <button mat-icon-button (click)="clearDropdown('teamName'); teamSelected.close()" class="clear-icon">
                                    <mat-icon>close</mat-icon>
                                </button>
                                <mat-option *ngFor="let model of listOfTeamName " value="{{model}}">
                                    {{model}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="toggle-box">
                            <mat-label ngClass="labelBeforeSlide">Pending Only</mat-label>
                            <mat-slide-toggle [(ngModel)]="isChecked">All Requests</mat-slide-toggle>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center" *ngIf="!isChecked">
                        <div class="overlay" *ngIf="refreshLoading">
                            <div class="center">
                                <mat-spinner class="mat-progress-spinner" color="accent"
                                             mode="indeterminate">
                                </mat-spinner>
                            </div>
                        </div>
                        <mat-table [dataSource]="dataSourceWork" matSort matTableFilter>
                            <ng-container *ngFor="let field of fieldNamesWork;let i=index" matColumnDef="{{field}}">
                                <th mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard">
                                    {{displayNamesWork[i]}}
                                </th>
                                <td mat-cell *matCellDef="let workAbroad" class="mat-column-standard center-text">

                                    <div *ngIf="field=='dateCreated'">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='startDate' && stringIOFormat== true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='startDate' && stringIOFormat==false && isClosed==true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='endDate' && stringIOFormat==true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='endDate' && stringIOFormat==false && isClosed==true">
                                        {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                    </div>

                                    <div *ngIf="field=='approve'&&workAbroad['requestStatus']=='PENDING'">
                                        <button [class.grey-out]="isDisabled" id="approve" class="close-button-right"
                                                (click)="approveWork(workAbroad)" [disabled]="isDisabled">
                                            Approve
                                        </button>
                                    </div>
                                    <div *ngIf="field=='decline'&&workAbroad['requestStatus']=='PENDING'">
                                        <button id="decline" class="close-button-right"
                                                (click)="declineWorkAbroad(workAbroad)">
                                            Decline
                                        </button>
                                    </div>
                                    <div *ngIf="field=='numberOfWorkAbroadDays'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field=='numberOfAnnualLeaveDays'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field !='numberOfWorkAbroadDays' && field !='startDate' && field !='endDate' && field !='dateCreated' && field !='numberOfAnnualLeaveDays'">
                                        {{workAbroad[field]| titlecase}}
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="fieldNamesWork; sticky: true;"></tr>
                            <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNamesWork;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>

                    <div fxLayoutAlign="center" fxLayout="row wrap" *ngIf="!isChecked">
                        <mat-paginator #workAbroadPaginator='matPaginator'
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center" *ngIf="isChecked">
                        <mat-table [dataSource]="dataSourceSwitchWorkManager" matSort matTableFilter>

                            <ng-container *ngFor="let field of fieldNamesWorkAllRequest;let i=index"
                                          matColumnDef="{{field}}">
                                <th mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard">
                                    {{displayNamesWorkAllRequest[i]}}
                                </th>
                                <td mat-cell *matCellDef="let workAbroad" class="mat-column-standard center-text"
                                    (click)="openAllRequestPopup(workAbroad,'workAbroad', filterEntity.year)">
                                    <div *ngIf="field=='workTaken'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field=='allowanceRemaining'">
                                        {{workAbroad[field]}}
                                    </div>
                                    <div *ngIf="field !=='allowanceRemaining' && field !=='workTaken'">
                                        {{workAbroad[field] |titlecase}}
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="fieldNamesWorkAllRequest; sticky: true;"></tr>
                            <tr mat-row
                                *matRowDef="let row = row; let even = even; columns: fieldNamesWorkAllRequest;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>

                    <div fxLayoutAlign="center" fxLayout="row wrap" *ngIf="isChecked">
                        <mat-paginator #switchWorkAbroadPaginator='matPaginator'
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>

                    <br/>
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <button class="buttons" *ngIf="!isExcelExporting" mat-raised-button color="primary"
                                type="button"
                                (click)="exportExcel('workAbroad')">
                            Export Excel
                        </button>
                    </div>
                </mat-tab>

                <mat-tab label="Vacation">
                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <mat-card class="day-cards green-card" *ngIf="isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle">Team Annual Leave
                                Entitlement
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{this.getDisplayValue.get('leaveEntitlement')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards red-card" *ngIf="isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"><br/> Remaining Days
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{this.getDisplayValue.get('remainingDays')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards amber-card" *ngIf="!isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Days
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{this.getDisplayValue.get('pendingDays')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards blue-card" *ngIf="!isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle"> Pending Requests
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{this.getDisplayValue.get('pendingRequests')}}
                            </mat-card-content>
                        </mat-card>
                        <mat-card class="day-cards blue-card" *ngIf="isChecked"><br/>
                            <mat-card-subtitle fxLayoutAlign="center" class="day-card-subtitle">Team Annual Leave
                                Used
                            </mat-card-subtitle>
                            <mat-card-content fxLayoutAlign="center" class="day-card-content">
                                {{this.getDisplayValue.get('daysUsed')}}
                            </mat-card-content>
                        </mat-card>
                    </div>
                    <br/>
                    <div fxLayoutAlign="center" fxLayout="row wrap" fxLayoutGap="8%">
                        <mat-form-field appearance="outline">
                            <mat-label>Search (First and Last Name)/GMIN</mat-label>
                            <input matInput (keyup)="filterTableDataSources()" #input [(ngModel)]="searchValue"/>
                            <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear"
                                    (click)="searchValue=''; filterTableDataSources()">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                        <mat-form-field appearance="outline" *ngIf="isChecked">
                            <mat-label>Year</mat-label>
                            <mat-select #selectedYear
                                        (selectionChange)="calculateDisplayValue(selectedYear.value,selectedTeam.value)"
                                        [(value)]="filterEntity.year">
                                <mat-option *ngFor="let model of year"
                                            value="{{model}}">{{model}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="outline" >
                            <mat-label>Team</mat-label>
                            <mat-select #selectedTeam
                                        [(value)]="filterEntity.teamName"
                                        (selectionChange)="calculateDisplayValue(filterEntity.year,selectedTeam.value)"
                                        placeholder="['All']">
                                <button mat-icon-button (click)="clearDropdown('teamName');this.selectedTeam.close()" class="clear-icon">
                                    <mat-icon>close</mat-icon>

                                </button>
                                <mat-option *ngFor="let model of listOfTeamName" value="{{model}}">
                                    {{model}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="toggle-box">
                            <mat-label ngClass="labelBeforeSlide">Pending Only</mat-label>
                            <mat-slide-toggle [(ngModel)]="isChecked">All Requests</mat-slide-toggle>
                        </div>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center" *ngIf="!isChecked">
                        <div class="overlay" *ngIf="refreshLoading">
                            <div class="center">
                                <mat-spinner class="mat-progress-spinner" color="accent"
                                             mode="indeterminate">
                                </mat-spinner>
                            </div>
                        </div>
                        <mat-table [dataSource]="dataSourceVacation" matSort matTableFilter>
                            <ng-container *ngFor="let field of fieldNamesVacation;let i=index"
                                          matColumnDef="{{field}}">
                                <th id="header" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard">
                                    {{displayNamesVacation[i]}}
                                </th>
                                <td mat-cell *matCellDef="let vacation" class="mat-column-standard center-text">
                                    <div *ngIf="field=='approve'&& vacation['requestStatus']=='PENDING'">
                                        <button [class.close-button-right]="!isDisabled" id="approve1"
                                                (click)="approveVacation(vacation)" [disabled]="isDisabled">Approve
                                        </button>
                                    </div>
                                    <div *ngIf="field=='decline'&&vacation['requestStatus']=='PENDING'">
                                        <button [class.close-button-right]="!isDisabled" id="decline1"
                                                (click)="openDeclineVacationPopUp(vacation)">Decline
                                        </button>
                                    </div>
                                    <div *ngIf="field=='dateCreated'">
                                        {{vacation[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='startDate' && stringIOFormat == true">
                                        {{vacation[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='endDate' && stringIOFormat == true">
                                        {{vacation[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='halfDay'">
                                        {{halfDayStatus(vacation[field])}}
                                    </div>
                                    <div *ngIf="field=='numberOfAnnualLeaveDays' || field=='absenceReason' && vacation['absenceReason'].length <= 25">
                                        {{vacation[field]}}
                                    </div>
                                    <div *ngIf="field=='absenceReason' && vacation['absenceReason'].length > 25"
                                         matTooltip="{{vacation[field]}}"
                                         matTooltipPosition="left">
                                        {{vacation[field].slice(0, 25) + '...'}}
                                    </div>
                                    <div *ngIf="field!=='dateCreated' && field!=='startDate' && field!=='endDate' && field!=='halfDay' && field!=='numberOfAnnualLeaveDays'&& field!=='absenceType' && field!=='absenceReason'">
                                        {{vacation[field] | titlecase}}
                                    </div>
                                    <div *ngIf="field=='absenceType'">
                                        {{ vacation[field] | titlecase | removeUnderscorePipe }}
                                    </div>

                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="fieldNamesVacation; sticky: true;"></tr>
                            <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNamesVacation;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>

                    <div fxLayoutAlign="center" fxLayout="row wrap" *ngIf="!isChecked">
                        <mat-paginator #vacationPaginator='matPaginator'
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>

                    <div fxLayout="row" fxLayoutAlign="center" *ngIf="isChecked">
                        <mat-table [dataSource]="dataSourceSwitchVacation" matSort matTableFilter
                                   [exampleEntity]="filterEntity">
                            <ng-container *ngFor="let field of fieldNamesVacationAllRequest;let i=index"
                                          matColumnDef="{{field}}">
                                <th mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard">
                                    {{displayNamesVacationAllRequest[i]}}
                                </th>
                                <td mat-cell *matCellDef="let vacation" class="mat-column-standard center-text"
                                    (click)="openAllRequestPopup(vacation,'vacation', filterEntity.year)">
                                    <div *ngIf="field=='dateCreated'">
                                        {{vacation[field] | date: 'dd/MM/yyyy'}}
                                    </div>
                                    <div *ngIf="field=='holidayTaken' ">
                                        {{vacation[field]}}
                                    </div>
                                    <div *ngIf="field=='vacationAllowanceRemaining' ">
                                        {{vacation[field]}}
                                    </div>
                                    <div *ngIf="field=='vacationAllowanceCarryover' ">
                                        {{vacation[field]}}
                                    </div>
                                    <div *ngIf="field!=='holidayTaken' && field!=='vacationAllowanceRemaining' && field!=='vacationAllowanceCarryover' && field!=='contractType'">
                                        {{vacation[field] |titlecase}}
                                    </div>
                                    <div *ngIf="field=='contractType'">
                                        {{ vacation[field] | titlecase | removeUnderscorePipe }}
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="fieldNamesVacationAllRequest; sticky: true;"></tr>
                            <tr mat-row
                                *matRowDef="let row = row; let even = even; columns: fieldNamesVacationAllRequest;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>

                    <div fxLayoutAlign="center" fxLayout="row wrap" *ngIf="isChecked">
                        <mat-paginator #switchVacationPaginator='matPaginator'
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>

                    <br/>
                    <div fxLayoutAlign="center center" fxLayout="row wrap">
                        <button class="buttons" *ngIf="!isExcelExporting" mat-raised-button color="primary"
                                type="button"
                                (click)="exportExcel('vacation')">
                            Export Excel
                        </button>
                        <button class="buttons" mat-raised-button color="primary" type="button"
                                (click)="openAbsenceCalendarPopup()">Absence Calender
                        </button>
                    </div>
                </mat-tab>

                <mat-tab label="Teams">
                    <br/>
                    <div fxLayout="row" fxLayoutAlign="center">
                        <div class="overlay" *ngIf="refreshLoading">
                            <div class="center">
                                <mat-spinner class="mat-progress-spinner" color="accent"
                                             mode="indeterminate">
                                </mat-spinner>
                            </div>
                        </div>
                        <mat-table [dataSource]="dataSourceTeam" matSort matTableFilter #teamTable>
                            <ng-container *ngFor="let field of teamFieldNames;let i=index"
                                          matColumnDef="{{field}}">
                                <th id="headers" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                    class="mat-column-headers-standard" style="text-align:center">
                                    {{displayTeamFieldNames[i]}}
                                </th>
                                <td mat-cell *matCellDef="let team; let i = index"
                                    class="mat-column-standard center-text">
                                    <div *ngIf="field=='teamName'">
                                        {{team[field]}}
                                    </div>
                                    <div *ngIf="field=='manager'">
                                        {{managerNames[i]}}
                                    </div>
                                    <div *ngIf="field=='alternateManager'">
                                        {{altManagerNames[i]}}
                                    </div>
                                    <div *ngIf="field=='edit'">
                                        <button id="edit" class="close-button-right" (click)="openEditTeamPopup(team)">
                                            Edit
                                        </button>
                                    </div>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="teamFieldNames; sticky: true;"></tr>
                            <tr mat-row
                                *matRowDef="let row = row; let even = even; columns: teamFieldNames;"
                                [ngClass]="{blueBackground : even}"></tr>
                        </mat-table>
                    </div>

                    <div fxLayoutAlign="center" fxLayout="row wrap">
                        <mat-paginator #teamsPaginator='matPaginator'
                                       [pageSize]="5"
                                       [pageSizeOptions]="[5, 10, 25, 50]"
                                       showFirstLastButtons
                                       class="blue">
                        </mat-paginator>
                    </div>

                </mat-tab>

                <mat-tab label="Cancel Requests">

                    <mat-tab-group #tabChange>

                        <mat-tab label="Vacation">
                            <br/>
                            <div fxLayoutAlign="center" fxLayout="row wrap" fxLayoutGap="8%">
                                <mat-form-field appearance="outline">
                                    <mat-label>Search (First and Last Name)/GMIN</mat-label>
                                    <input matInput (keyup)="filterTableDataSources()" #input [(ngModel)]="searchValue"/>
                                    <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear"
                                            (click)="searchValue=''; filterTableDataSources()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field>
                                <mat-form-field appearance="outline" >
                                    <mat-label>Team</mat-label>
                                    <mat-select #selectedTeam
                                                [(value)]="filterEntity.teamName"
                                                (selectionChange)="calculateDisplayValue(filterEntity.year,selectedTeam.value)"
                                                placeholder="['All']">
                                        <button mat-icon-button (click)="clearDropdown('teamName');this.selectedTeam.close()" class="clear-icon">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        <mat-option *ngFor="let model of listOfTeamName" value="{{model}}">
                                            {{model}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div fxLayout="row" fxLayoutAlign="center">
                                <div class="overlay" *ngIf="refreshLoading">
                                    <div class="center">
                                        <mat-spinner class="mat-progress-spinner" color="accent"
                                                     mode="indeterminate">
                                        </mat-spinner>
                                    </div>
                                </div>
                                <mat-table [dataSource]="dataSourceCancelVacationRequests" matSort matTableFilter>
                                    <ng-container *ngFor="let field of fieldNamesVacationCancel;let i=index"
                                                  matColumnDef="{{field}}">
                                        <th id="header1" mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                            class="mat-column-headers-standard">
                                            {{displayNamesVacationCancel[i]}}
                                        </th>
                                        <td mat-cell *matCellDef="let vacation" class="mat-column-standard center-text">
                                            <div *ngIf="field=='approve/decline'&&vacation['requestStatus']=='CANCEL_REQUEST'">
                                                <button [class.grey-out]="isDisabled" id="declineCancel" class="close-button-right"
                                                        (click)="openApproveOrDeclineVacationRequest(vacation)" [disabled]="isDisabled">Approve/Decline
                                                </button>
                                            </div>
                                            <div *ngIf="field=='dateCreated'">
                                                {{vacation[field] | date: 'dd/MM/yyyy'}}
                                            </div>
                                            <div *ngIf="field=='startDate' && stringIOFormat == true">
                                                {{sortDate(vacation[field])}}
                                            </div>
                                            <div *ngIf="field=='endDate' && stringIOFormat == true">
                                                {{sortDate(vacation[field])}}
                                            </div>
                                            <div *ngIf="field=='halfDay'">
                                                {{halfDayStatus(vacation[field])}}
                                            </div>
                                            <div *ngIf="field=='numberOfAnnualLeaveDays' || field=='absenceReason' && vacation['absenceReason'].length <= 25">
                                                {{vacation[field]}}
                                            </div>
                                            <div *ngIf="field=='absenceReason' && vacation['absenceReason'].length > 25"
                                                 matTooltip="{{vacation[field]}}"
                                                 matTooltipPosition="left">
                                                {{vacation[field].slice(0, 25) + '...'}}
                                            </div>
                                            <div *ngIf="field!=='dateCreated' && field!=='startDate' && field!=='endDate' && field!=='halfDay' && field!=='numberOfAnnualLeaveDays'&& field!=='absenceType' && field!=='absenceReason' && field!=='requestStatus'">
                                                {{vacation[field] | titlecase}}
                                            </div>
                                            <div *ngIf="field=='absenceType'">
                                                {{ vacation[field] | titlecase | removeUnderscorePipe }}
                                            </div>
                                            <div *ngIf="field=='requestStatus'">
                                                {{ vacation[field] | titlecase | removeUnderscorePipe }}
                                            </div>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="fieldNamesVacationCancel; sticky: true;"></tr>
                                    <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNamesVacationCancel;"
                                        [ngClass]="{blueBackground : even}"></tr>
                                </mat-table>
                            </div>

                            <div fxLayoutAlign="center" fxLayout="row wrap">
                                <mat-paginator #vacationCancelPaginator='matPaginator'
                                               [pageSize]="5"
                                               [pageSizeOptions]="[5, 10, 25, 50]"
                                               showFirstLastButtons
                                               class="blue">
                                </mat-paginator>
                            </div>
                        </mat-tab>

                        <mat-tab label="Work Abroad">
                            <br/>
                            <div fxLayoutAlign="center" fxLayout="row wrap" fxLayoutGap="8%">
                                <mat-form-field appearance="outline">
                                    <mat-label>Search (First and Last Name)/GMIN</mat-label>
                                    <input matInput (keyup)="filterTableDataSources()" #input [(ngModel)]="searchValue"/>
                                    <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear"
                                            (click)="searchValue=''; filterTableDataSources()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field>
                                <mat-form-field appearance="outline" >
                                    <mat-label>Team</mat-label>
                                    <mat-select #selectedTeam
                                                [(value)]="filterEntity.teamName"
                                                (selectionChange)="calculateDisplayValue(filterEntity.year,selectedTeam.value)"
                                                placeholder="['Enter Names']">
                                        <button mat-icon-button (click)="clearDropdown('teamName'); this.selectedTeam.close()" class="clear-icon">
                                            <mat-icon>close</mat-icon>
                                        </button>
                                        <mat-option *ngFor="let model of listOfTeamName " value="{{model}}">
                                            {{model}}</mat-option>
                                    </mat-select>
                                </mat-form-field>

                            </div>

                            <div fxLayout="row" fxLayoutAlign="center">
                                <div class="overlay" *ngIf="refreshLoading">
                                    <div class="center">
                                        <mat-spinner class="mat-progress-spinner" color="accent"
                                                     mode="indeterminate">
                                        </mat-spinner>
                                    </div>
                                </div>
                                <mat-table [dataSource]="dataSourceCancelWorkRequests" matSort matTableFilter>
                                    <ng-container *ngFor="let field of fieldNamesWorkCancel;let i=index" matColumnDef="{{field}}">
                                        <th mat-header-cell mat-sort-header="{{field}}" *matHeaderCellDef
                                            class="mat-column-headers-standard">
                                            {{displayNamesWorkCancel[i]}}
                                        </th>
                                        <td mat-cell *matCellDef="let workAbroad" class="mat-column-standard center-text">

                                            <div *ngIf="field=='dateCreated'">
                                                {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                            </div>
                                            <div *ngIf="field=='startDate' && stringIOFormat== true">
                                                {{sortDate(workAbroad[field])}}
                                            </div>

                                            <div *ngIf="field=='startDate' && stringIOFormat==false && isClosed==true">
                                                {{workAbroad[field] | date: 'dd/MM/yyyy'}}
                                            </div>

                                            <div *ngIf="field=='endDate' && stringIOFormat==true">
                                                {{sortDate(workAbroad[field])}}
                                            </div>

                                            <div *ngIf="field=='endDate' && stringIOFormat==false && isClosed==true">
                                                {{workAbroad[field]}}
                                            </div>

                                            <div *ngIf="field=='approve/decline'&&workAbroad['requestStatus']=='CANCEL_REQUEST'">
                                                <button [class.grey-out]="isDisabled" id="declineCancelWork" class="close-button-right"
                                                        (click)="openApproveOrDeclineWorkAbroadRequest(workAbroad)" [disabled]="isDisabled">Approve/Decline
                                                </button>
                                            </div>

                                            <div *ngIf="field=='numberOfWorkAbroadDays'">
                                                {{workAbroad[field]}}
                                            </div>
                                            <div *ngIf="field=='numberOfAnnualLeaveDays'">
                                                {{workAbroad[field]}}
                                            </div>
                                            <div *ngIf="field !='numberOfWorkAbroadDays' && field !='startDate' && field !='endDate' && field !='dateCreated' && field !='numberOfAnnualLeaveDays' && field !='requestStatus'">
                                                {{workAbroad[field]| titlecase}}
                                            </div>
                                            <div *ngIf="field=='requestStatus'">
                                                {{workAbroad[field]| titlecase | removeUnderscorePipe}}
                                            </div>
                                        </td>
                                    </ng-container>
                                    <tr mat-header-row *matHeaderRowDef="fieldNamesWorkCancel; sticky: true;"></tr>
                                    <tr mat-row *matRowDef="let row = row; let even = even; columns: fieldNamesWorkCancel;"
                                        [ngClass]="{blueBackground : even}"></tr>
                                </mat-table>
                            </div>
                            <div fxLayoutAlign="center" fxLayout="row wrap">
                                <mat-paginator #workAbroadCancelPaginator='matPaginator'
                                               [pageSize]="5"
                                               [pageSizeOptions]="[5, 10, 25, 50]"
                                               showFirstLastButtons
                                               class="blue">
                                </mat-paginator>
                            </div>
                        </mat-tab>
                    </mat-tab-group>

                </mat-tab>

            </mat-tab-group>
        </div>
    </div>
</div>
<fab-loading-spinner *ngIf="!isLoading"></fab-loading-spinner>
<div *ngIf="!isManager">
    <p class="not-a-manager">You are not a manager of any team(s).</p>
    <p class="not-a-manager">Please contact HR for further assistance</p>
</div>